<template>
  <div ref="container">
    <TagAnnotateForm
      :recent-tags="recentTags"
      :show-loader="showLoader"
      :existing-selected-tag="cachedData"
      @annotateCallSubmit="annotateCallSubmit"
      @cacheFormData="cacheFormData"
      @closeForm="$emit('closeForm')"
    />
  </div>
</template>

<script>
import callLogActionFormsMixin from '../callLogActionFormsMixin';
import TagAnnotateForm from './TagAnnotateForm';

export default {
  name: 'CallAnnotateForm',
  
  components: {
    TagAnnotateForm
  },

  mixins: [callLogActionFormsMixin],

  props: {
    recentTags: {
      type: Array,
      default() {
        return [];
      }
    },
    cachedData: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  methods: {
    cacheFormData(tag) {
      this.$emit('cacheFormData', tag);
    },

    annotateCallSubmit(tag) {
      this.$emit('annotateCallSubmit', tag);
    },
  },
};
</script>

<style>

</style>